import request from '../utils/request';

const momentPostApi = {
  // 分页查询动态
  pageMomentPosts: (params = {}) => {
    return request.post('/moment-post/page', {
      page: 1,
      pageSize: 10,
      ...params
    });
  },

  // 获取动态详情
  getMomentPostDetail: (id) => {
    return request.get(`/moment-post/${id}`);
  },

  // 更新动态状态
  updateMomentPostStatus: (id, data) => {
    return request.put(`/moment-post/status/${id}`, data);
  },

  // 创建动态（管理员）
  createMomentPost: (data) => {
    return request.post('/moment-post', data);
  },

  // 删除动态
  deleteMomentPost: (id) => {
    return request.delete(`/moment-post/${id}`);
  }
};

export default momentPostApi;
